/** Standard Indian GST rate slabs (% of taxable value). */
export const VALID_GST_RATES = [0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28];
/** True if `rate` matches a recognised GST slab. */
export function isValidGSTRate(rate) {
    return VALID_GST_RATES.includes(rate);
}
